import featureImg01 from '../../../assets/feature_img01.png';
import banner01 from '../../../assets/banner01.png';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-robot-line',
      title: 'AI탐험여권',
      description:
        '내 여권에 도장이 하나씩 늘어날 때마다 진짜 탐험가가 되어가요! AI와 함께하는 나만의 성장 기록!',
      image: featureImg01
    },
    {
      icon: 'ri-live-line',
      title: 'AI체험여행',
      description:
        '우리 아이가 만든 이야기가 진짜 동화책이 된다면? AI로 동화책도 만들고 노래도 만드는 신기한 체험, 아이와 함께 즐겨 보세요!',
      image:
        'https://readdy.ai/api/search-image?query=Elementary%20school%20children%20participating%20in%20live%20online%20class%20with%20teacher%20on%20screen%20interactive%20virtual%20classroom%20with%20bright%20colors%20and%20educational%20materials%20students%20raising%20hands%20and%20engaging%20actively&width=400&height=300&seq=live-class-001&orientation=landscape'
    },
    {
      icon: 'ri-gamepad-line',
      title: 'AI놀이여행',
      description:
        'AI와 함께라면 매일매일 새로운 놀이가 기다리는 AI놀이여행 출발!',
      image:
        'https://readdy.ai/api/search-image?query=Children%20playing%20educational%20games%20on%20tablets%20and%20computers%20with%20colorful%20game%20interfaces%20showing%20math%20puzzles%20and%20science%20quizzes%20bright%20cheerful%20learning%20environment%20with%20achievement%20badges%20and%20rewards&width=400&height=300&seq=game-learning-001&orientation=landscape'
    },
    {
      icon: 'ri-group-line',
      title: 'AI기초여행',
      description:
        "AI는 어떻게 그림도, 이야기도, 노래도 척척 만들어 낼까요? 그 비밀의 열쇠는 다름 아닌 '글쓰기'예요. 함께 써볼까요?",
      image:
        'https://readdy.ai/api/search-image?query=Small%20group%20of%20elementary%20students%20learning%20together%20in%20virtual%20classroom%20collaborative%20learning%20environment%20with%20teacher%20guidance%20interactive%20whiteboards%20and%20educational%20tools%20bright%20and%20engaging%20atmosphere&width=400&height=300&seq=small-group-001&orientation=landscape'
    },
    {
      icon: 'ri-trophy-line',
      title: 'AI응용여행',
      description:
        '아이의 손끝에서 탄생하는 다양한 AI 작품들, 체험을 거듭할수록 우리 아이만의 특별한 포트폴리오가 쌓여 가요.',
      image:
        'https://readdy.ai/api/search-image?query=Elementary%20school%20children%20participating%20in%20after-school%20care%20program%20with%20AI%20technology%20online%20activities%20connecting%20school%20and%20home%20educational%20support%20system%20with%20teachers%20and%20caregivers%20collaborating%20bright%20supportive%20learning%20environment&width=400&height=300&seq=care-connection-001&orientation=landscape'
    },
    {
      icon: 'ri-links-line',
      title: 'AI프로젝트여행',
      description:
        '우리 아이의 놀라운 작품을 직접 만나 보세요! AI 웹툰, 뮤직비디오, 애니메이션, 음악까지 상상이 현실이 되는 특별한 시간이에요.',
      image:
        'https://readdy.ai/api/search-image?query=Children%20celebrating%20learning%20achievements%20with%20digital%20badges%20trophies%20and%20certificates%20on%20screen%20colorful%20reward%20system%20with%20stars%20and%20medals%20happy%20students%20showing%20progress%20charts&width=400&height=300&seq=achievement-001&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            아이노우 라이브 클래스만의{' '}
            <span className="text-blue-600">특별함</span>
          </h2>
          <p className="md:text-xl text-lg text-gray-600 max-w-3xl mx-auto">
            최신 AI 기술과 전문 튜터가 함께하는 혁신적인 체험을 만나 보세요.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="mb-6">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-48 object-cover rounded-xl mb-4"
                />
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <a
            href="http://aiknow.ai.kr/main/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
          >
            <img src={banner01} alt=""/>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
